import React from 'react';
import appGoogleTracking from '../../../modules/googletracking';

/*
    Google tagging plan added on links using : appGoogleTracking.processEventCTA
*/

const footersocialV1 = () => (
    <div className="footer__social">
        <a className="js-event-cta"
            href=" https://www.instagram.com/milka_austria/"
            target="_blank"
            data-event="go_to_social_media"
            data-category="Footer"
            data-action="Go to Social Media"
            data-label="Instagram"
            rel="noopener noreferrer"
            onClick={appGoogleTracking.processEventCTA}>
            <span >
                <img src={'/resources/icons/instagram.svg'} alt="Milka Tiktok" />
            </span>
            <span style={{marginTop: '2px'}} className='icon_text'> INSTAGRAM</span>
        </a>
        <a className="js-event-cta"
            href="https://www.facebook.com/MilkaDACH/"
            target="_blank"
            data-event="go_to_social_media"
            data-category="Footer"
            data-action="Go to Social Media"
            data-label="Facebook"
            rel="noopener noreferrer" onClick={appGoogleTracking.processEventCTA}>
            <span >
                <img src={'/resources/icons/facebook.svg'} alt="Milka Tiktok" />
            </span>
            <span style={{marginTop: '5px'}}  className='icon_text'> FACEBOOK</span>
        </a>
        <a className="js-event-cta"
            href="https://www.youtube.com/@Milka/playlists"
            target="_blank"
            rel="noopener noreferrer"
            data-event="go_to_social_media"
            data-category="Footer"
            data-action="Go to Social Media"
            data-label="Youtube"

            onClick={appGoogleTracking.processEventCTA}>
            <span className="icon-youtube">
                <img style={{position:'relative', top:'-13px'}} src={'/resources/icons/youtube.svg'} alt="Milka Tiktok" />
            </span>
            <span  className='icon_text'> YOUTUBE</span>
        </a>
        <a className="js-event-cta"
            href="https://pinterest.de/milka_dach"
            target="_blank"
            rel="noopener noreferrer"
            data-event="go_to_social_media"
            data-category="Footer"
            data-action="Go to Social Media"
            data-label="Pinterest"
            onClick={appGoogleTracking.processEventCTA}>
            <span className="icon-pinterest"></span>
            <span className='icon_text'> PINTEREST</span>
        </a>

        <a className="js-event-cta"
            href="https://www.tiktok.com/@milka_de_at"
            target="_blank"
            rel="noopener noreferrer"
            data-event="go_to_social_media"
            data-category="Footer"
            data-action="Go to Social Media"
            data-label="TikTok"
            onClick={appGoogleTracking.processEventCTA}>
            <span className="icon-tiktok">
                <img src={'/resources/icons/Vector.png'} alt="Milka Tiktok" />
            </span>
            <span className='icon_text'> TikTok</span>

        </a>
    </div>
);

export default footersocialV1;